import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnfold = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.4697 1.21967C11.7626 0.926777 12.2374 0.926777 12.5303 1.21967L15.7803 4.46967C16.0732 4.76256 16.0732 5.23744 15.7803 5.53033C15.4874 5.82322 15.0126 5.82322 14.7197 5.53033L12.75 3.56066V8.25C12.75 8.66421 12.4142 9 12 9C11.5858 9 11.25 8.66421 11.25 8.25V3.56066L9.28033 5.53033C8.98744 5.82322 8.51256 5.82322 8.21967 5.53033C7.92678 5.23744 7.92678 4.76256 8.21967 4.46967L11.4697 1.21967Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.75 12C2.75 11.5858 3.08579 11.25 3.5 11.25H4.5C4.91421 11.25 5.25 11.5858 5.25 12C5.25 12.4142 4.91421 12.75 4.5 12.75H3.5C3.08579 12.75 2.75 12.4142 2.75 12Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5002 11.25C11.086 11.25 10.7502 11.5858 10.7502 12C10.7502 12.4142 11.086 12.75 11.5002 12.75H12.5002C12.9145 12.75 13.2502 12.4142 13.2502 12C13.2502 11.5858 12.9145 11.25 12.5002 11.25H11.5002Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.25 15.75V20.4393L9.28033 18.4697C8.98744 18.1768 8.51257 18.1768 8.21967 18.4697C7.92678 18.7626 7.92678 19.2374 8.21967 19.5303L11.4697 22.7803C11.6103 22.921 11.8011 23 12 23C12.1989 23 12.3897 22.921 12.5303 22.7803L15.7803 19.5303C16.0732 19.2374 16.0732 18.7626 15.7803 18.4697C15.4874 18.1768 15.0126 18.1768 14.7197 18.4697L12.75 20.4393V15.75C12.75 15.3358 12.4142 15 12 15C11.5858 15 11.25 15.3358 11.25 15.75Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5001 11.25C15.0859 11.25 14.7501 11.5858 14.7501 12C14.7501 12.4142 15.0859 12.75 15.5001 12.75H16.5001C16.9143 12.75 17.2501 12.4142 17.2501 12C17.2501 11.5858 16.9143 11.25 16.5001 11.25H15.5001Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.75 12C6.75 11.5858 7.08579 11.25 7.5 11.25H8.5C8.91421 11.25 9.25 11.5858 9.25 12C9.25 12.4142 8.91421 12.75 8.5 12.75H7.5C7.08579 12.75 6.75 12.4142 6.75 12Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5 11.25C19.0858 11.25 18.75 11.5858 18.75 12C18.75 12.4142 19.0858 12.75 19.5 12.75H20.5C20.9142 12.75 21.25 12.4142 21.25 12C21.25 11.5858 20.9142 11.25 20.5 11.25H19.5Z",
			fill: "var(--colors-grey-1)"
		})
	]
});
export default SvgUnfold;
